import { render, staticRenderFns } from "./AgendaClosure.vue?vue&type=template&id=91c05402&scoped=true&"
import script from "./AgendaClosure.vue?vue&type=script&lang=js&"
export * from "./AgendaClosure.vue?vue&type=script&lang=js&"
import style0 from "./AgendaClosure.vue?vue&type=style&index=0&id=91c05402&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c05402",
  null
  
)

export default component.exports